export default __webpack_public_path__ + "static/media/1_0144.a3bd8d33.webp";